import React from 'react'
import { Route } from 'react-router'
import {RolloutLandingPageContainer, RolloutConfirmedPageContainer} from '../RolloutLandingPage'
import {NewPageContainer} from '../NewPage'
import {EditPageContainer} from '../EditPage'
import {ShowPageContainer} from '../ShowPage'
import {IndexRoutes} from '../IndexPage'
import 'normalize.css/normalize.css'
import {VotePageRouterContainer} from '../RolloutContest/VotePage/VotePageRouter'

export const routes = (
  <Route>
    <Route path='vote' component={VotePageRouterContainer} />
    {IndexRoutes}
    <Route path='rollout' component={RolloutLandingPageContainer} />
    <Route path='rollout/:page' component={RolloutLandingPageContainer} />
    <Route path='rollout_confirmed' component={RolloutConfirmedPageContainer} />
    <Route path='new' component={NewPageContainer} />
    <Route path=':slug' component={ShowPageContainer} />
    <Route path=':slug/edit' component={EditPageContainer} />
  </Route>
)
